require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');

var TheView = GenericView.extend({
    el: ".location-container",
    tagName: "div",
    currentMarkerOnMap: null, //current Marker on the map
    markers: null, //saved markers
    map: null,
    geocoder: null,
    addressMode: false,
    pos: { //default map center, Thessaloniki
        lat: 40.6401,
        lng: 22.9444
    },
    mapOptions: {
        center: new google.maps.LatLng( 40.6401, 22.9444 ),
        zoom: 12,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false
    },
    initialize: function(options) {
        this.geocoder = new google.maps.Geocoder();
        this.renderMap();
        this.initAutocomplete();
    },
    renderMap: function() {
        var self = this;
        this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);
        this.geocoder = new google.maps.Geocoder();

        google.maps.event.addListener(this.map, 'click', function(event) {
           self.placeMarkerOnMap(event.latLng);
           self.fillInputsWithLatLng(event.latLng.lat(),event.latLng.lng());
        });
    },
    events: {
        "click .searchBtn": "search",
        "focus .focus": "focus"
    },
    placeMarkerOnMap: function(latLngParams) {
        if(this.currentMarkerOnMap == null) {
            this.currentMarkerOnMap = new google.maps.Marker({
                position: latLngParams,
                map: this.map
            });
        } else {
            this.currentMarkerOnMap.setPosition(latLngParams);
            this.currentMarkerOnMap.setMap(this.map);
        }

        this.map.setZoom(13);
        this.map.setCenter(latLngParams);

        // for Electricity Pricing -> Flat Pricing
        var latLng =  {
            "lat": latLngParams.lat instanceof Function ? latLngParams.lat() : latLngParams.lat,
            "lng": latLngParams.lng instanceof Function ? latLngParams.lng() : latLngParams.lng
       };

        $(window).trigger("map:latLngChange", [latLng]);
    },
    initAutocomplete: function() {
        var self = this;

        // Create the search box and link it to the UI element.
        var input = document.getElementById('mapLocationSearchbox');
        var searchBox = new google.maps.places.SearchBox(input);

        // Listen for the event fired when the user selects a prediction and retrieve
        // more details for that place.
        searchBox.addListener('places_changed', function() {
            var places = searchBox.getPlaces();

            if (places.length == 0) {
                return;
            }

            // For each place, get the icon, name and location.
            places.forEach(function(place) {
                if (!place.geometry) {
                  console.log("Returned place contains no geometry");
                  return;
                }
                var icon = {
                  url: place.icon,
                  size: new google.maps.Size(71, 71),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(17, 34),
                  scaledSize: new google.maps.Size(25, 25)
                };

                //create marker
                self.placeMarkerOnMap(place.geometry.location);

                //fill lat and lng inputs
                self.fillInputsWithLatLng(place.geometry.location.lat(), place.geometry.location.lng());
            });

        });
    },
    search: function() {
        if (this.addressMode == true) {
            if ( $('.mapLocationSearchbox').val() != null ){
                var searchText = $('.mapLocationSearchbox').val();
                this.searchWithAddress(searchText);
            }
        } else {
            if ($(".lat").val() != "" && $(".lng").val() != "" ){
                var lat = $(".lat").val();
                var lng = $(".lng").val();
                this.searchWithLatLng(lat,lng);
            }
        }
    },
    searchWithLatLng: function(lat,lng) {
        var self = this;
        latLng = new google.maps.LatLng(parseFloat(lat),parseFloat(lng));
        this.geocoder.geocode( { 'location': latLng }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {

                self.placeMarkerOnMap(results[0].geometry.location);
                $(".mapLocationSearchbox").val("");
            }
        });
    },
    fillInputsWithLatLng: function(lat,lng){
        $(".lat").val(lat);
        $(".lng").val(lng);
    },
    focus: function (e) {
        if ( $(e.target).hasClass("lat") || $(e.target).hasClass("lng") ) {
            this.addressMode = false;
        } else {
            this.addressMode = true;
        }
    }

});

module.exports = TheView;